import { api } from 'services/api';
import { headers } from 'helpers/utils';

export const uploadTile = async (file) => {
	const formData = new FormData();
	formData.append('file', file);

	const response = await api.post(`/tiles`, formData, {
		headers: {
			...headers(),
			'Content-Type': 'multipart/form-data'
		}
	});

	const { data } = response;

	return data;
};

export const fetchUserTiles = async () => {
	const response = await api.get(`/users/tiles`, {
		headers: headers()
	});
	return response.data;
};

export const deleteTile = async (tileId) => {
	await api.delete(`/tiles/${tileId}`, {
		headers: headers()
	});
};

const tokenCache = new Map();

export async function getTileToken(tileId) {
	try {
		const cached = tokenCache.get(tileId);

		if (cached && cached.expiresAt > Date.now()) {
			return cached.token;
		}

		const res = await api.post(`/tiles/${tileId}/token`, {}, { headers: headers() });

		const { data } = res;

		if (!data?.token) {
			throw new Error('Token inválido.');
		}

		const expiresAt = Date.now() + data.expiresIn * 1000;

		tokenCache.set(tileId, {
			token: data.token,
			expiresAt
		});

		return data.token;
	} catch (err) {
		const message =
			err?.response?.data?.message || // mensagem do backend
			'Erro ao obter token do mapa.'; // fallback

		throw new Error(message);
	}
}
